import React, { useEffect, useRef, useState } from "react";
import { Grid, Eye } from "lucide-react";

export default function MapContextHeader({
    gridMode,
    setGridMode,
    snapEnabled,
    setSnapEnabled,
}) {
    const Item = ({ value, label }) => (
        <label className="flex items-center gap-1.5 text-xs text-gray-300 cursor-pointer">
            <input
                type="radio"
                name="grid-mode"
                value={value}
                checked={gridMode === value}
                onChange={() => setGridMode(value)}
                className="accent-action-400"
            />
            {label}
        </label>
    );

    return (
        <div
            className="
        absolute top-0 left-0 right-0 z-30
        h-10 px-3
        flex items-center justify-between
        bg-bg-soft/90 backdrop-blur
        border-b border-bg-border
      "
        >
            {/* LEFT: GRID CONTEXT */}
            <div className="flex items-center gap-4 text-[11px]">
                <Grid size={14} className="text-gray-400" />
                <Toggle
                    label="No Grid"
                    enabled={gridMode === "none"}
                    onChange={(v) => setGridMode("none")}
                />

                <Toggle
                    label="DH Grid"
                    enabled={gridMode === "dh"}
                    onChange={(enabled) => {
                        setGridMode(enabled ? "dh" : "none");
                    }}
                />

                <Toggle
                    label="Snap to Grid"
                    enabled={snapEnabled}
                    onChange={setSnapEnabled}
                />
            </div>

            {/* RIGHT: RESERVED */}
            <div className="flex items-center gap-3 text-xs text-gray-400">
                <Eye size={14} />
                Image Preview
            </div>
        </div>
    );
}

function Toggle({ label, enabled, onChange }) {
  return (
    <button
      onClick={() => onChange(!enabled)}
      className="
        flex items-center gap-2 px-2 py-1 rounded
        border border-bg-border
        text-[11px]
        transition-colors
        text-gray-400
        hover:bg-bg-soft
      "
    >
      <div
        className={`
          w-3 h-3 rounded-sm border
          transition-colors
          ${enabled
            ? "bg-orange-500 border-orange-500"
            : "border-gray-500"}
        `}
      />
      <span
        className={enabled ? "text-orange-400" : ""}
      >
        {label}
      </span>
    </button>
  );
}